import * as React from "react";
import { Link } from "gatsby";
import T from "../T/T";
import { LocaleLink } from "../../lib/IntlTools";
import "./styles.scss";

export default function TermsAccordion() {
  return (
    <div className="uk-container">
      <div className="terms-body-holder">
        <ul className=" footer-menu-list">
          <li>
            <Link className="uk-accordion-title"
                  replace={true}
                  to={LocaleLink("/terms/")}>
              <T>footer-item-1</T>
            </Link>
          </li>
          <li>
            <Link className="uk-accordion-title"
                  replace={true}
                  to={LocaleLink("/privacy/")}>
              <T>footer-item-2</T>
            </Link>
          </li>
          <li>
            <Link className="uk-accordion-title"
                  replace={true}
                  to={LocaleLink("/cookies/")}>
              <T>footer-item-3</T>
            </Link>
          </li>
          <li>
            <Link className="uk-accordion-title"
                  replace={true}
                  to={LocaleLink("/contacts/")}>
              <T>footer-item-4</T>
            </Link>
          </li>
          <li>
            <Link className="uk-accordion-title"
                  replace={true}
                  to={LocaleLink("/dppd/")}>
              <T>footer-item-5</T>
            </Link>
          </li>
        </ul>
      </div>
    </div>
  )
}
